import styled from 'styled-components'

import Button from 'components/UI/Button'

const FormButton = styled(Button)`
  float: right;
  margin-top: 10px;
  margin-left: 10px;
`

export default FormButton



// WEBPACK FOOTER //
// ./src/components/UI/Form/FormButton.jsx